import { render } from "./PriceModal.vue?vue&type=template&id=d3958dec"
import script from "./PriceModal.vue?vue&type=script&lang=js"
export * from "./PriceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__